import * as React from 'react';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import Pagination from '@mui/material/Pagination';
import { NavLink } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { postRequest } from '../../lib/api';
import { AuthContext } from '../../authContext/context';
import { useContext, useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Swal from 'sweetalert2';
import BreadcrumbsWrapper from '../../components/breadcrumbs'
import { checkPermission } from '../../utils/checkPermissions';
import PermissionWrapper from '../../components/PermissionWrapper';


export default function PartnerRateCards() {
  const [partnerList, setPartnerList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalDocs, setTotalDocs] = useState(0);
  const [searchName, setSearchName] = useState('');
  const authCtx = useContext(AuthContext);
  const userPermissions = authCtx.permissions;

  // Check permission
  const canManagePartners = checkPermission(userPermissions, 'settings', 'manage_partners');

  // Debounce ref
  const debounceRef = useRef();

  // Fetch partners API
 const fetchPartners = async (searchNameVal, pageVal = page) => {
  setLoading(true);
  try {

    const payload = {
      page: pageVal,
      limit: 10,
      name: searchNameVal,
    };

    const response = await postRequest('private/PartnerList', payload, authCtx.token);
    if (response?.status === 200 && response?.data) {
      setPartnerList(response.data.docs || []);
      setTotalPages(response.data.totalPages || 1);
      setTotalDocs(response.data.totalDocs || 0);
    } else {
      setPartnerList([]);
      setTotalPages(1);
      setTotalDocs(0);
    }
  } catch (err) {
    setPartnerList([]);
    setTotalPages(1);
    setTotalDocs(0);
  }
  setLoading(false);
};

  // Fetch on mount and when page changes
  useEffect(() => {
    fetchPartners(searchName, page);
    // eslint-disable-next-line
  }, [page, authCtx.token]);

  // Debounced search on name change
  useEffect(() => {
    setPage(1); // Reset to first page on search
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      fetchPartners(searchName, 1);
    }, 400);
    // eslint-disable-next-line
  }, [searchName]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };


  return (
    <PermissionWrapper
      category="settings"
      permission="manage_partners"
      pageTitle="Partner Rate Cards"
      breadcrumbs={[
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Partner Rate Cards', path: '' },
      ]}
    >
      <>
       <BreadcrumbsWrapper
               items={[
                { label: 'Dashboard', path: '/dashboard' },
                { label: 'Partner Rate Cards', path: '' },
                  ]}
                   />
          <br></br>
      <div className='page-header'>
        <h1 className='mt-0'>Partner Rate Cards</h1>
      </div>
      {/* <div className='page-top-formview mb-3'>
        <Form>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="searchUsername">
              <Form.Control
                type="text"
                placeholder="Enter partner name"
                value={searchName}
                onChange={e => {
                  setSearchName(e.target.value);
                  setPage(1);
                }}
              />
            </Form.Group>
          </Row>
        </Form>
      </div> */}

      <div>
        <Table striped responsive bordered>
          <thead>
            <tr>
              <th>Partner Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={2} style={{ textAlign: 'center' }}>
                  <CircularProgress size={28} />
                </td>
              </tr>
            ) : partnerList.length === 0 ? (
              <tr>
                <td colSpan={2} style={{ textAlign: 'center' }}>
                  No partners found.
                </td>
              </tr>
            ) : (
              partnerList.map((partner) => (
                <tr key={partner._id}>
                  <th>{partner.name}</th>
                  <td>
                    <span
                      className='red-link-text cursor-pointer w-18'
                      title="View Partner Rate Cards"
                      style={{ marginRight: 8 }}
                    >
                      <NavLink to={`/partner-rate-cards/view/${partner._id}`} className="red-link-text">
                        <VisibilityOutlinedIcon />
                      </NavLink>
                    </span>
                    <span
                      className='red-link-text cursor-pointer w-18'
                      title="Manage Products"
                      style={{ marginRight: 8 }}
                    >
                      <NavLink to={`/partner-rate-cards/view/${partner._id}`} className="red-link-text">
                        <EditOutlinedIcon />
                      </NavLink>
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
        {/* Pagination */}
      {partnerList.length > 0 && (
  <>
    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 8, marginBottom: 8 }}>
      <span className="text-muted small">
        Showing {((page - 1) * 10) + 1}-{Math.min(page * 10, totalDocs)} of {totalDocs} partners
      </span>
    </div>
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 8 }}>
      <Pagination
        count={totalPages}
        page={page}
        onChange={handlePageChange}
        color="primary"
        shape="rounded"
        size="medium"
        sx={{
                  '& .Mui-selected': {
                    background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%) !important',
                    color: '#fff !important',
                  },
                  '& .MuiPaginationItem-root': {
                    color: 'var(--bs-red-color)',
                    borderColor: 'var(--bs-red-color)',
                  },
                }}
      />
    </div>
  </>
)}

      </div>
      </>
    </PermissionWrapper>
  );
}
